module.exports = __webpack_public_path__ + "static/media/banco-do-brasil-ico.1500a892.svg";